var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * Email component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconEmail extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M2.60449 5.36668C2.60449 4.9189 2.96749 4.55591 3.41526 4.55591H20.5837C21.0315 4.55591 21.3945 4.9189 21.3945 5.36668V5.41089L12.5155 12.9868C12.3703 13.1066 12.1879 13.1722 11.9995 13.1722C11.8111 13.1722 11.6287 13.1066 11.4835 12.9868L2.60449 5.41086V5.36668ZM2.60449 7.38269L10.5138 14.1313L10.5206 14.137C10.9358 14.4828 11.4591 14.6722 11.9995 14.6722C12.5399 14.6722 13.0632 14.4829 13.4784 14.137L21.3945 7.3827V18.6332C21.3945 19.081 21.0315 19.444 20.5837 19.444H3.41526C2.96749 19.444 2.60449 19.081 2.60449 18.6332V7.38269ZM22.8945 5.76317V18.6332C22.8945 19.9094 21.8599 20.944 20.5837 20.944H3.41526C2.13906 20.944 1.10449 19.9094 1.10449 18.6332V5.75649V5.36668C1.10449 4.09047 2.13906 3.05591 3.41526 3.05591H20.5837C21.8599 3.05591 22.8945 4.09047 22.8945 5.36668V5.74982C22.8945 5.75427 22.8945 5.75872 22.8945 5.76317Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconEmail.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconEmail.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconEmail.prototype, "size", void 0);
if (customElements.get('cat-icon-email') === undefined) {
    customElements.define('cat-icon-email', BlocksIconEmail);
}
